import { useState } from "react";
import { deepReads } from "@/mocks/guaData";

export default function Story() {
  const [followed, setFollowed] = useState<number[]>([0]);

  const toggle = (id: number) =>
    setFollowed((prev) => (prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]));

  return (
    <section id="story" className="scroll-mt-28 bg-paper-50">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <div className="flex flex-col gap-2 md:flex-row md:items-end md:justify-between">
          <div>
            <div className="mb-1 text-xs font-semibold tracking-[0.2em] text-primary-600">DEEP READING</div>
            <h2 className="font-serif text-2xl font-extrabold tracking-tight text-stone-900 md:text-3xl">深度专题 · 不止吃个瓜</h2>
          </div>
          <p className="max-w-md text-sm leading-relaxed text-stone-500">把热点讲透：关系怎么理、情绪从哪来、信息如何被加工。观点不代表定论，只想陪你多想一层。</p>
        </div>

        <div className="mt-9 space-y-7">
          {deepReads.map((d, i) => {
            const flipped = i % 2 === 1;
            const isFollowed = followed.includes(i);
            return (
              <article
                key={d.tag + i}
                className="grid grid-cols-1 overflow-hidden rounded-lg border border-paper-200 bg-white md:grid-cols-2"
              >
                <div className={`relative min-h-52 md:min-h-full ${flipped ? "md:order-2" : ""}`}>
                  <img src={d.image} alt={d.title} className="absolute inset-0 h-full w-full object-cover" />
                  <span className="absolute left-3 top-3 rounded-md bg-black/45 px-2.5 py-1 text-xs font-semibold text-white backdrop-blur">
                    {d.tag}
                  </span>
                </div>
                <div className={`flex flex-col justify-center p-6 md:p-8 ${flipped ? "md:order-1" : ""}`}>
                  <span className="font-serif text-4xl font-extrabold text-paper-300">{String(i + 1).padStart(2, "0")}</span>
                  <h3 className="mt-2 font-serif text-xl font-bold leading-snug text-stone-900 md:text-2xl">{d.title}</h3>
                  <p className="mt-3 text-sm leading-relaxed text-stone-600">{d.lead}</p>
                  <ul className="mt-4 space-y-2">
                    {d.points.map((p) => (
                      <li key={p} className="flex items-center gap-2.5 text-sm text-stone-700">
                        <span className="flex h-5 w-5 items-center justify-center rounded-full bg-primary-50 text-primary-500">
                          <i className="ri-check-line text-xs" />
                        </span>
                        {p}
                      </li>
                    ))}
                  </ul>
                  <div className="mt-5">
                    <button
                      type="button"
                      onClick={() => toggle(i)}
                      className={`inline-flex cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-md px-4 py-2 text-sm font-medium transition ${
                        isFollowed
                          ? "bg-primary-500 text-white hover:bg-primary-600"
                          : "border border-primary-200 bg-primary-50 text-primary-700 hover:bg-primary-100"
                      }`}
                    >
                      <i className={isFollowed ? "ri-checkbox-circle-line" : "ri-add-circle-line"} />
                      {isFollowed ? "追更中" : "加入追更"}
                    </button>
                  </div>
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}